import * as React from "react";
import { api, dataList } from "src/services/api";
import { FormState, Form, Fieldset, bindToAPI, resetState } from "src/services/form";
import { Formatters, Loading } from "src/components/ui";

interface Props {
  onDefault?: Function;
  onChange?: Function;
  onEdit?: Function;
}

interface State extends FormState {
  loading?: boolean;
  phase: string;
  current?: any;
  indirizzi: any[];
  validate?: any;
}

export default class IndirizziFatturazione extends React.Component<Props, State> {
  state = {
    phase: "LIST",
    indirizzi: []
  } as State
  
  async componentWillMount() {
    const { onChange } = this.props;
    const data = await api( {
      url: "ecommerce/userInfo",
      loading: this
    });
    const current = this.detectDefault(data.indirizzi);
    if (onChange) {
      onChange( current );
    }
    this.setState({
      indirizzi: data.indirizzi,
      current
    });
  }
  
  detectDefault( indirizzi ) {
    const f = indirizzi.filter( i => i.predefinito );
    return f.length > 0 ? f[0] : null;
  }
  
  focus(current) {
    const { onChange } = this.props;
    if (onChange) {
      onChange( current );
    }
    this.setState({
      current
    });
  }
  
  setDefault(item) {
    const { onDefault } = this.props;
    const { indirizzi = [] } = this.state;
    if (onDefault) {
      onDefault( item );
    }
    // collect
    const _indirizzi = dataList.flag( indirizzi, "predefinito", item);
    // save
    this.save( { indirizzi: _indirizzi } );
  }
  
  create() {
    const { onEdit } = this.props;
    if (onEdit) {
      onEdit(true);
    }
    this.setState(resetState({
      phase: "EDIT"
    }));
  }
  
  edit( item ) {
    const { onEdit } = this.props;
    if (onEdit) {
      onEdit(item);
    }
    this.setState({
      phase: "EDIT",
      item: item
    });
  }
  
  cancel() {
    const { onEdit } = this.props;
    if (onEdit) {
      onEdit(false);
    }
    this.setState(resetState({
      phase: "LIST"
    }));
  }
  
  destroy( item ) {
    let { indirizzi = [], current } = this.state;
    indirizzi = dataList.destroy( indirizzi, item );
    this.save( { indirizzi } );
    // detect if current is deleted
    let found = false;
    if (current) {
      let found = indirizzi.filter( i => i.id === current.id ).length > 0;
    }
    if (!found) {
      // set current by default one
      this.setState({
        current: this.detectDefault(indirizzi)
      })
    }
  }
  
  submit(values: any) {
    // collect
    const { item, indirizzi = [] } = this.state;
    const { onEdit } = this.props;
    const _indirizzi = dataList.update( indirizzi, values, item );
    const _item = Object.assign( {}, item, values );
    // save
    this.save( { indirizzi: _indirizzi, item: _item } );
    if (onEdit) {
      onEdit(false);
    }
  }

  validate(values) {
    this.setState(values);
  }
  
  async save( args ) {
    try {
      const data = await bindToAPI( this, {
            method: "POST",
            url: "ecommerce/userInfo",
            data: args,
            loading: this
      });
      this.setState({
        phase: "LIST",
        indirizzi: data.indirizzi
      });
    } catch(errors) {
      
    }
    
    // workaround?
    self.location.href = '#'; 
    self.location.href = '#up';
  }
  
  render() {
    const { loading, errors, current, phase, item, indirizzi = [], validate} = this.state;
    if (loading) return <Loading />;
    return (
      <div className="ecommerce_IndirizziFatturazione">
        {phase === "LIST" &&
        <section className="items">
          <header>
            <h3>Dati di fatturazione</h3>
          </header>
          {indirizzi.length > 0 &&
          <div className="list">
          {indirizzi.map( (src,i) => {
          const v = Object.assign(src);
          return (
            <article key={i} onClick={() => this.focus(v)}>
              <div className={current && current.id == v.id ? 'active' : ""}>
                <div>
                  <span className="checker"><span className={current && current.id == v.id ? "icon-radio-on" : "icon-radio-off"} /></span>
                  <div>
                    {v.nome} {v.cognome}<br />
                    <Formatters.Address {...v.indirizzo} />
                    {v.partita_iva &&
                    <div>P.I. {v.partita_iva}</div>
                    }
                    {v.codice_fiscale &&
                    <div>C.F. {v.codice_fiscale}</div>
                    }
                    {v.telefono &&
                    <div>Tel. {v.telefono}</div>
                    }
                  </div>
                  <div className="remove">
                    <button className="frameless" onClick={() => this.destroy(v)}><span className="icon-remove" /></button>
                  </div>
                </div>
                <nav>
                  <span>
                    <button className="link edit" onClick={(e) => { e.preventDefault(); this.edit(v); } }>Modifica</button>
                  </span>
                  <span>
                  {!v.predefinito &&
                    <button className="link select" onClick={() => this.setDefault(v)}>Imposta predefinito</button>
                  }
                  {v.predefinito &&
                    <span className="is-default">Predefinito</span>
                  }
                  </span>
                </nav>
              </div>
            </article>
          );
          })}
          </div>
          }
          {indirizzi.length === 0 &&
          <div className="none">
            Nessun indirizzo ancora inserito.
          </div>
          }
          <button className="wicon pre frameless-blue" onClick={() => this.create()}><span><span className="icon-add" /><em>Aggiungi un indirizzo</em></span></button>
        </section>
        }
        {phase === "EDIT" &&
        <section className="edit">
          <Form onSubmit={values => this.submit(values)} onChange={(formState, formApi) => { this.setState({validate: Date.now()}); }} validateOnMount={true} defaultValues={item || null} render={(form) => {
            return (
              <form onSubmit={form.submitForm}>
              <br/>
                <Fieldset
                  form={form}
                  model="indirizzoFatturazione"
                  fields={[
                    'tipo', 'nome', 'cognome', 'ragione_sociale', 'indirizzo', 'telefono', 'sdi', 'emailpec', 'partita_iva', 'codice_fiscale'
                  ]}
                  fieldsParams={{
                    'tipo': { type: 'radio' },
                    'nome': { size: 50 },
                    'cognome': { size: 50 },
                    'telefono': { size: 100 },
                    'sdi': { size: 50 },
                    'emailpec': { size: 50 },
                    'partita_iva': { size: 50 },
                    'codice_fiscale': { size: 50 }
                  } as any}
                  errors={errors}
                  validate={validate}
                />
                <footer className="toolbar">
                  <button type="button" className="wicon pre frameless" onClick={() => this.cancel()}><span><span className="icon-caret-left" /><em>Annulla</em></span></button>
                  <button className="main md" type="submit" disabled={form.errors}><span>Salva</span></button>
                </footer>
              </form>
            )
          }} />
        </section>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/IndirizziFatturazione.tsx